import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from 'store/reducers';
import { isDevelopment } from 'utils/constants/constants';

export default function configureStore(preloadedState = {}) {
  const devtools = isDevelopment ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;
  const middleware = devtools(applyMiddleware(thunk));
  const store = createStore(rootReducer, preloadedState, middleware);

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }

  return store;
}
